import { useState } from 'react';

export default function Products() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const products = [
    {
      id: 1,
      title: 'VPN Protection',
      description: 'Military-grade encryption ensuring your online privacy and security across all networks',
      image: 'https://public.readdy.ai/ai/img_res/a25b956b4127a676b5812fd625da85e5.jpg',
      gradient: 'from-blue-900/80 via-purple-900/70 to-transparent'
    },
    {
      id: 2,
      title: 'Smart Cleaner',
      description: 'Intelligent storage optimization removing junk files and boosting device performance effortlessly',
      image: 'https://readdy.ai/api/search-image?query=clean%20organized%20digital%20interface%20with%20teal%20and%20green%20gradient%20overlay%2C%20storage%20optimization%20visualization%2C%20organized%20file%20system%20icons%2C%20performance%20boost%20indicators%2C%20minimalist%20iOS%20app%20interface%20elements%2C%20fresh%20modern%20design%2C%20smooth%20gradients%2C%20professional%20mobile%20optimization%20theme&width=800&height=1000&seq=cleaner-card-001&orientation=portrait',
      gradient: 'from-teal-900/80 via-green-900/70 to-transparent'
    },
    {
      id: 3,
      title: 'Complete Solution',
      description: 'Comprehensive mobile protection combining security and performance in one seamless experience',
      image: 'https://readdy.ai/api/search-image?query=unified%20mobile%20app%20interface%20showing%20security%20and%20performance%20features%20together%2C%20purple%20and%20pink%20gradient%20overlay%2C%20combined%20VPN%20and%20cleaner%20functionality%20visualization%2C%20holistic%20protection%20concept%2C%20modern%20iOS%20design%20elements%2C%20sophisticated%20tech%20aesthetic%2C%20seamless%20integration%20theme&width=800&height=1000&seq=combined-card-001&orientation=portrait',
      gradient: 'from-purple-900/80 via-pink-900/70 to-transparent'
    }
  ];

  return (
    <section id="products" className="py-24 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-widest bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent font-semibold mb-4">
            OUR PRODUCTS
          </p>
          <h2 className="text-5xl font-bold text-gray-900">
            Security & Performance 🛡️
          </h2>
        </div>

        {/* Product Cards Grid */}
        <div className="grid grid-cols-3 gap-6" data-product-shop>
          {products.map((product, index) => (
            <div
              key={product.id}
              className={`relative rounded-2xl overflow-hidden shadow-lg transition-all duration-500 cursor-pointer ${
                hoveredCard === index ? 'col-span-1 scale-105' : 'col-span-1'
              }`}
              style={{ minHeight: '500px' }}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              {/* Background Image */}
              <div className="absolute inset-0 w-full h-full">
                <img 
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${product.gradient}`}></div>
              </div>

              {/* Content */}
              <div className="relative h-full flex flex-col justify-end p-8">
                <h3 className="text-3xl font-bold text-white mb-3">
                  {product.title}
                </h3>
                <p className="text-base text-white/80 leading-relaxed">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}